(ns manage.content-variant-page.entities.tracker.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Select$default" :as Select]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.widgets.form-field :refer [form-field]]
            [manage.content-variant-page.entities.tagging-tracker-ocp.macro-input :refer [macro-input]]
            [manage.content-variant-page.entities.tracker.db :as tracker]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui tracker-list-item-fields [{:keys [index tracker-type value-text]}]
  ($ Stack {:direction "row" :gap 2}
     ($ form-field
        {:sx #js {:flexBasis "34%"}
         :label "Tracker type"
         :data-testid "tracker-param-type-select"}
        ($ Select {:sx #js {:width "100%"}
                   :size "small"
                   :value (or tracker-type "")
                   :onChange (fn [^js event]
                               (let [value (-> event .-target .-value)]
                                 (rf/dispatch [::tracker/set-tracker-type index value])))}
           ($ MenuItem {:value "click"} "Click")
           ($ MenuItem {:value "impression"} "Impression")))
     ($ form-field
        {:sx #js {:flexBasis "66%"}
         :label "Value"
         :data-testid "tracker-param-value-input"}
        (r/as-element
         [macro-input {:value (or value-text "")
                       :allow-macros? true
                       :on-change (fn [value]
                                    (rf/dispatch [::tracker/set-tracker-value index value]))}]))
     ($ IconButton
        {:sx #js {:alignSelf "flex-end"}
         :onClick (fn [^js _event]
                    (rf/dispatch [::tracker/delete-tracker-param index]))
         :data-testid "delete-tracker-param"}
        ($ Icon "delete"))))

(defui tracker-list-item-message [{:keys [index]}]
  (let [invalid-tracker-url-error-message (use-subscribe [::tracker/invalid-tracker-url-error-message index])
        only-1-click-tracker-error (use-subscribe [::tracker/only-1-click-tracker-error index])
        overridden-click-tracker-warning (use-subscribe [::tracker/overridden-click-tracker-warning index])
        {:keys [message color] :as warning-map}
        (cond
          only-1-click-tracker-error {:message "It's not possible to add multiple Click Trackers to the same adset."
                                      :color "error.main"}
          overridden-click-tracker-warning {:message "Another Click Tracker coming from the feed was identified and will take precedence over this one."
                                            :color "warning.main"}
          invalid-tracker-url-error-message {:message invalid-tracker-url-error-message
                                             :color "error.main"})]
    (when warning-map
      ($ Stack {:direction "row"
                :alignItems "center"
                :spacing 1
                :sx #js {:my 1
                         :color color}}
         ($ Icon "warning")
         ($ Typography message)))))

(defui tracker-list-item [{:keys [index tracker-type value-text]}]
  ($ :<>
     ($ tracker-list-item-fields {:index index :tracker-type tracker-type :value-text value-text})
     ($ tracker-list-item-message {:index index})))

(defui tab-panel []
  ($ Stack {:spacing 2}
     (for [[index {:keys [type value]}] (mc/seq-indexed (use-subscribe [::tracker/tracker-params]))]
       ($ tracker-list-item {:key index :index index :tracker-type type :value-text value}))
     ($ Button {:startIcon ($ Icon "add")
                :variant "text"
                :onClick (fn [^js _event]
                           (rf/dispatch [::tracker/add-tracker-param]))
                :sx #js {:alignSelf "start"}}
        "Add new tracker")))
